import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import hocExports from '../../../../../../../components/Toolbar/components/HocExports'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocExports
@hocConnect
export default class ExportsDesk extends Component {
    static propTypes = {
        exportXls: PropTypes.bool.isRequired,
        getExport: PropTypes.func.isRequired,
        groupName: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        portfolioType: PropTypes.string.isRequired,
        showUpsellDialog: PropTypes.func.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.id !== nextProps.id) return true
        if (this.props.module !== nextProps.module) return true
        if (this.props.portfolioType !== nextProps.portfolioType) return true
        if (this.props.groupName !== nextProps.groupName) return true
        if (this.props.exportXls !== nextProps.exportXls) return true

        return false
    }

    handleExcelExportClick = () => {
        const { exportXls, module, id, groupName, portfolioType, getExport, showUpsellDialog } = this.props

        if (exportXls) {
            getExport(module, id, 'xls', `${module}_${groupName}_export`, {
                body: { userState: { typeReport: portfolioType } },
            })
        } else {
            showUpsellDialog()
        }
    }

    render() {
        return (
            <div className={'report-exports-desk'}>
                <>
                    <div className={'title'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.title`} />
                    </div>
                    <div className={'content'}>
                        <div className={'content-row'} onClick={this.handleExcelExportClick}>
                            <div className={'icon type-xls'} />
                            <FormattedMessage id={`${LOCALE_PREFIX}.exportXls`} />
                        </div>
                    </div>
                </>
            </div>
        )
    }
}
